import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'pulse-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit {
  @Input() showMyAccount: boolean

  @Output() closeSessionEvent = new EventEmitter<boolean>();

  constructor(public router: Router) {}

  ngOnInit(): void {}

  closeSession() {
    this.closeSessionEvent.emit();
  }

  goToMyAccount() {
    this.router.navigate(['/admin/account']);
  }
}
